import PropTypes from 'prop-types';

import { RowContext } from '#src/rows/RowContext.js';
import { useComponents } from '#src/lib/component-mappings/index.js';

const slugify = (title, id) =>
  `${title}-${id}`.toLowerCase().replace(/[^0-9a-z]+/g, '-');

const ContentRow = ({
  contentTypeId,
  entryId,
  internalTitle,
  componentNamespace,
  ...props
}) => {
  const { [contentTypeId]: Cmp = 'div' } = useComponents();
  if (!contentTypeId) return null;
  return (
    <RowContext.Provider value={slugify(internalTitle, entryId)}>
      <Cmp {...{ contentTypeId, internalTitle, ...props }} />
    </RowContext.Provider>
  );
};

ContentRow.propTypes = {
  contentTypeId: PropTypes.string.isRequired,
};

export default ContentRow;
